import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';


@Component({
  selector: 'app-contact-edit',
  templateUrl: './contact-edit.component.html',
  styleUrls: ['./contact-edit.component.scss']
})
export class ContactEditComponent implements OnInit {

  contactForm: FormGroup;
  editDetails;
  constructor(private formBuilder:FormBuilder, private router:Router,
  public util:UtilService,
    public httpService:HttpServiceService, public alertService:AlertService,
    public loaderService:LoaderService) {
    
  }

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      id: ['', [Validators.required]],
              information: ['', [Validators.required]],
              phone: ['', [Validators.required]],
              email: ['', [Validators.required]],
              timings: ['', [Validators.required]],
              address: ['', [Validators.required]],
            });
            this.loaderService.showLoader('Please wait while fetching ..').then(()=>{
    
              this.editDetails = JSON.parse(localStorage.getItem('editData'))
              this.contactForm.patchValue(this.editDetails);
              this.loaderService.hideLoader();
   /* this.loaderService.showLoader('Please wait while fetching ..').then(()=>{
    
    this.editDetails = JSON.parse(localStorage.getItem('editData'))
    this.editDetails.contactInfo = "";
    this.editDetails.contactInfo = this.editDetails.contact_information ? this.editDetails.contact_information : "";
    console.log(this.editDetails)
    this.contactForm.patchValue(this.editDetails);
    this.loaderService.hideLoader(); */
  })

  }

  submit(data) {
    data['createdAt']= new Date().getTime();
    this.loaderService.showLoader('Updating Please wait ..').then(()=>{
      try{
        this.httpService.postApi(data,`/client/update_contact_details?information=${data.information}&id=${data.id}&phone=${data.phone}&email=${data.email}&address=${data.address}&timings=${data.address})`).subscribe((res: any) => {
          this.loaderService.hideLoader();
          if (res["success"]) {
            this.alertService.presentAlert('success','Successfully updated','Okay');
            this.router.navigate(['/front-end/contact/contact-list'])
          } else {
            this.alertService.presentAlert('Error',res["error"]["success"],'Okay');
          }
        },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });    
      }catch(e){
        this.loaderService.hideLoader();
        this.alertService.presentAlert('Error','Something went wrong please try again','Okay');
      }
    })
    
  }

}
